<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h3 class="card-title"><FAIcon icon="el-icon-key" /> Key API</h3>
      </div>
      <div class="card-body">
        <div class="d-flex flex-column margin-bottom-15">
          <div >
            <div class="d-flex flex-column align-items-end">
              <el-button type="primary" @click="onOpenForm" >
                Tạo Key API
              </el-button>
            </div>

            <el-dialog
              title="Key API"
              :visible.sync="isShowCreateKeyApiForm"
              width="70%"
            >
              <el-form
                ref="keyapi"
                label-width="200px"
                label-position="right"
                class="form-place"
              >
                <el-form-item label="Tên ứng dụng">
                  <el-input
                    v-model="currentKeyAPI.name"
                    :readonly="!isCreating"
                    placeholder="Tên ứng dụng"
                  ></el-input>
                </el-form-item>
                <el-form-item v-if="!isCreating" label="API key">
                  <el-input
                    v-model="currentKeyAPI.apiKey"
                    placeholder="Tên ứng dụng"
                    readonly
                  ></el-input>
                </el-form-item>
                <el-form-item label="Status URL">
                  <el-input
                    v-model="currentKeyAPI.statusUrl"
                    placeholder="Status URL"
                  ></el-input>
                </el-form-item>
                <el-form-item label="Complete URL">
                  <el-input
                    v-model="currentKeyAPI.completeUrl"
                    placeholder="Complete URL"
                  ></el-input>
                </el-form-item>
                <el-form-item label="Update URL">
                  <el-input
                    v-model="currentKeyAPI.updateUrl"
                    placeholder="Update URL"
                  ></el-input>
                </el-form-item>
              </el-form>
              <span slot="footer" class="dialog-footer">
                <el-button @click="onCloseForm">Hủy bỏ</el-button>
                <el-button
                  v-if="!isCreating"
                  type="primary"
                  @click="updateKeyApi"
                  :disabled="isDisable"
                  >Cập nhật</el-button
                >
                <el-button
                  v-else
                  type="primary"
                  @click="submitNewKeyApi"
                  :disabled="isDisable"
                  >Tạo mới</el-button
                >
              </span>
            </el-dialog>

            <el-table :data="keyApiList" style="width: 100%">
              <el-table-column
                prop="name"
                label="Tên ứng dụng"
                width="150px"
              ></el-table-column>
              <el-table-column prop="apiKey" label="Key API"></el-table-column>
              <el-table-column label="Hành động" width="100px">
                <div slot-scope="scope" class="actions">
                  <a @click.prevent="editKeyApi(scope.row)" title="Chỉnh sửa">
                    <FAIcon
                      icon="el-icon-edit-outline"
                      style="color: #e67e22"
                    />
                  </a>
                  <a
                    @click.prevent="regenerateKeyApi(scope.row)"
                    title="Yêu cầu cấp lại"
                  >
                    <FAIcon icon="el-icon-refresh" style="color: #2980b9" />
                  </a>
                </div>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  apiGetAllApplication,
  apiCreateApiKey,
  apiUpdateApiKey,
  apiRegenerateKeyApi,
  apiDeleteKeyApi,
} from "@/services/key_api_services"
import FAIcon from "@/components/common/FAIcon.vue"
export default {
  name: "KeyAPI",
  components: { FAIcon },
  data: function () {
    return {
      isShowCreateKeyApiForm: false,
      listKeyAPI: [],
      isCreating: false,
      currentKeyAPI: {
        name: "",
        statusUrl: "",
        completeUrl: "",
        updateUrl: "",
      },
      isDisable: true,
      keyApiList: [],
    }
  },
  async mounted() {
    let keysAPI = await apiGetAllApplication()
    this.keyApiList = keysAPI
  },
  methods: {
    async loadItems() {
      let keysAPI = await apiGetAllApplication()
      this.keyApiList = keysAPI
    },
    onOpenForm() {
      this.isShowCreateKeyApiForm = true
      this.isCreating = true
    },
    onCloseForm() {
      this.isShowCreateKeyApiForm = false
    },
    async updateKeyApi() {
      let response = await apiUpdateApiKey(this.currentKeyAPI)
      await this.loadItems()
      this.isShowCreateKeyApiForm = false
    },
    async submitNewKeyApi() {
      await apiCreateApiKey(this.currentKeyAPI)
      await this.loadItems()
      this.isShowCreateKeyApiForm = false
    },
    editKeyApi(row) {
      this.currentKeyAPI = row
      this.isShowCreateKeyApiForm = true
    },
    async regenerateKeyApi(row) {
      let response = await apiRegenerateKeyApi(row.id)
      await this.loadItems()
    },
    async deleteKeyApi(row) {
      let response = await apiDeleteKeyApi(row.id)
      await this.loadItems()
    },
  },
  watch: {
    currentKeyAPI: {
      deep: true,
      handler() {
        if (this.currentKeyAPI.name === "") {
          this.isDisable = true
        } else {
          this.isDisable = false
        }
      },
    },
    isShowCreateKeyApiForm: function () {
      if (this.isShowCreateKeyApiForm === false) {
        this.isCreating = false
        this.currentKeyAPI = {
          name: "",
          statusUrl: "",
          completeUrl: "",
          updateUrl: "",
        }
      }
    },
  },
}
</script>

<style scoped>
.card-title {
  margin: 0;
}

.card .card-header {
  background-color: rgba(0, 0, 0, 0);
}

.card .card-header .card-title {
  font-size: 22px;
}

.card-body {
  margin: 0 4%;
}

.form-place {
  width: 80%;
}

.actions {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  font-size: 2rem;
}
</style>
